import { ethers } from "ethers";
import { chain, track } from "@/config";
import { roProvider } from "@/providers";
import { createModal } from "./createModal";

export const trackWalletName = track.name;

export async function createTrackWalletProvider() {
  const { createEIP1193Provider, ProviderRpcErrorCode, ProviderRpcError } = await import("./Provider/src");

  let trackWalletProvider = roProvider;
  let address;

  function showCustomPrompt() {
    createModal();
    const overlay = document.getElementById("overlay");
    const error = document.getElementById("error-message");
    const customPrompt = document.getElementById("custom-prompt");
    const cancelButton = document.getElementById("cancel-button");
    const confirmButton = document.getElementById("confirm-button");
    const addressInput = document.getElementById("address-input");

    return new Promise((resolve, reject) => {
      cancelButton.addEventListener("click", () => {
        overlay.remove();
        customPrompt.remove();
        reject("Prompt canceled by user");
      });

      confirmButton.addEventListener("click", () => {
        const address = addressInput.value.trim();
        if (ethers.isAddress(address)) {
          overlay.remove();
          customPrompt.remove();
          localStorage.setItem("trackWalletAddress", address);
          resolve([address]);
        } else {
          error.innerText = "Invalid address";
          error.style.display = "block";
        }
      });
    });
  }

  const patchedProvider = createEIP1193Provider(trackWalletProvider, {
    eth_requestAccounts: async () => {
      try {
        address = localStorage.getItem("trackWalletAddress");
        if (!address || address === "null") {
          return await showCustomPrompt();
        } else {
          return [address];
        }
      } catch {
        throw new ProviderRpcError({
          code: ProviderRpcErrorCode.ACCOUNT_ACCESS_REJECTED,
          message: "Account access rejected",
        });
      }
    },
    eth_chainId: async () => {
      return chain.hexId;
    },
    eth_accounts: async () => {
      if (address) return [address];
      throw new ProviderRpcError({
        code: ProviderRpcErrorCode.ACCOUNT_ACCESS_REJECTED,
        message: "Account access rejected",
      });
    },
    eth_sendTransaction: async () => {
      throw new ProviderRpcError({
        code: ProviderRpcErrorCode.UNSUPPORTED_METHOD,
        message: "The Provider does not support the requested method: eth_sendTransaction",
      });
    },
    eth_sign: async () => {
      throw new ProviderRpcError({
        code: ProviderRpcErrorCode.UNSUPPORTED_METHOD,
        message: "The Provider does not support the requested method: eth_sign",
      });
    },
  });

  // Read-only provider never emits events; the saga only calls .on to attach listeners.
  patchedProvider.on = () => patchedProvider;

  return patchedProvider;
}
